const BG = "https://images.unsplash.com/photo-1666555038185-8323c553de64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwc3RlZWwlMjBtZXRhbCUyMHRleHR1cmUlMjBkYXJrfGVufDB8fHx8MTc4NTgzMzEyNHww&ixlib=rb-4.1.0&q=85";

export const AuthShell = ({ caption, title, children }) => (
  <div className="min-h-screen grid lg:grid-cols-[55%_45%] bg-[#FBFAF8]">
    <div className="relative hidden lg:block overflow-hidden">
      <img src={BG} alt="Stål" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0E0E0E]/90 via-[#141414]/80 to-[#141414]/85" />
      <div className="relative z-10 h-full flex flex-col justify-between p-14 text-white">
        <img src="/bsm-logo-white.png" alt="BSM A/S — vision in steel" className="h-11 w-auto self-start" />
        <div>
          <h1 className="text-5xl font-light tracking-tight leading-[1.05]">Projektportal</h1>
          <p className="mt-5 text-white/60 max-w-md text-base leading-relaxed">Få adgang til projekter, dokumenter, fremdrift og samarbejde – samlet ét sted.</p>
        </div>
        <p className="text-white/40 text-sm">© {new Date().getFullYear()} BSM A/S</p>
      </div>
    </div>
    <div className="flex items-center justify-center p-6 sm:p-12">
      <div className="w-full max-w-sm rise-in">
        <img src="/bsm-logo.png" alt="BSM A/S — vision in steel" className="h-9 w-auto mb-10 lg:hidden" />
        <p className="label-caps">{caption}</p>
        <h2 className="text-3xl sm:text-4xl font-light tracking-tight mt-2 mb-9 text-[#1A1919]">{title}</h2>
        {children}
      </div>
    </div>
  </div>
);
